/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, Routes, useLocation } from 'react-router-dom';

import DefaultLayout from '@layout/index';
import authenticationPresenter from '@modules/authentication/presenter';
import { TokenSelector } from '@modules/authentication/profileStore';
import { useSingleAsync } from '@shared/hook/useAsync';

import { privateRouter } from '../index';
import ShowRouter from './ShowRouter';

const PrivatePage: React.FC = () => {
  const getProfile = useSingleAsync(authenticationPresenter.getProfile);
  const token = useSelector(TokenSelector);
  const location = useLocation();
  const route = ShowRouter({ routers: privateRouter, privateRoute: true });

  useEffect(() => {
    if (token) {
      getProfile.execute();
    }
  }, [token]);

  const showMasterLayout = React.useMemo(() => {
    const r = route.routes.find(it => it.path && matchPath(it.path, location.pathname));
    return r?.masterLayout !== false;
  }, [location.pathname, route.routes]);

  const showwidthFull = React.useMemo(() => {
    const result = route?.routes?.find(it => it.path && matchPath(it.path, location.pathname));
    return result?.widthFull;
  }, [location.pathname, route.routes]);

  return (
    <DefaultLayout
      loading={getProfile.status !== 'ready'}
      hideHeader={!showMasterLayout}
      hideSideBar={!showMasterLayout}
      widthFull={showwidthFull}
    >
      <Routes>{route.views}</Routes>
    </DefaultLayout>
  );
};
export default React.memo(PrivatePage);
